module.exports = __webpack_public_path__ + "static/media/at.fa4cf043.svg";